<button
  [attr.type]="type"
  [ngClass]="{ borderless: borderlsess, 'full-width': fullWidth() }"
  [disabled]="disabled"
>
  {{ label | translate }}
</button>
